import * as React from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectLibraryResearchItemsInfo } from "../../selectors/selectLibraryInfo";
import { GridContainer } from "../generic/grid-layout/GridContainer";
import { GridItemLibrary } from "./GridItemLibrary";
var _MasterViewLibrary = function (_a) {
    var researchItems = _a.researchItems, onSelect = _a.onSelect;
    var _b = useState(0), selectedItemIndex = _b[0], setSelectedItemIndex = _b[1];
    useEffect(function () {
        onSelectResearchItem(selectedItemIndex);
    }, [researchItems[selectedItemIndex].level]);
    var onSelectResearchItem = function (index) {
        var researchItem = researchItems[index];
        setSelectedItemIndex(index);
        if (onSelect) {
            onSelect(researchItem);
        }
    };
    return (React.createElement("div", { className: "flex h100 w100" },
        React.createElement(GridContainer, { items: researchItems, selectedIndex: selectedItemIndex, onSelect: onSelectResearchItem, gridItemRenderer: GridItemLibrary })));
};
var mapState = function (state) { return ({
    researchItems: selectLibraryResearchItemsInfo(state),
}); };
export var MasterViewLibrary = connect(mapState)(_MasterViewLibrary);



//////////////////
// WEBPACK FOOTER
// ./src/features/library/MasterViewLibrary.tsx
// module id = 2696
// module chunks = 3